export const ConfigConstants = {
    CAS_SERVICE_URL: "casServiceUrl",
    CAS_CLIENT_ID: "casServiceClientId",
    TPSC_URL: "tpscBaseUri"
};
